import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";

import bgAudio from "../images/Aviator/audio/sfxBg.mp3";
import background from "../images/Aviator/bg.png";
import centerImg from "../images/Aviator/Loading.png";
import planeImgOneSrc from "../images/Aviator/rocket-one.png";
import planeImgTwoSrc from "../images/Aviator/rocket-two.png";
import startSound from "../images/Aviator/audio/sfxRocketStart.mp3";
import crashSound from "../images/Aviator/audio/sfxRocketCrash.mp3";

const cssStyles = `
@keyframes spin-fast {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.animate-spin-fast { animation: spin-fast 1.2s linear infinite; }

.rotating-bg-img {
  position: absolute;
  top: 100%; left: 0%;
  object-fit: cover;
  transform: translate(-50%, -50%) scale(5);
  z-index: 0;
}
.spin-animate { animation: spin 20s linear infinite; }
@keyframes spin {
  100% { transform: translate(-50%, -50%) scale(5) rotate(360deg); }
}

@keyframes breath {
  0%, 100% { transform: scale(1);   opacity: 0.6; }
  50%       { transform: scale(1.2); opacity: 1;   }
}
@keyframes gradientShift {
  0%   { background: linear-gradient(135deg, #1b1c1d, #1b1c1d); }
  20%  { background: linear-gradient(135deg, #34b4ff, #1b1c1d); }
  45%  { background: linear-gradient(135deg, #913ef8, #1b1c1d); }
  70%  { background: linear-gradient(135deg, #c017b4, #1b1c1d); }
}
.animate-gradient-blur {
  animation: gradientShift 20s ease-in-out infinite, breath 3s ease-in-out infinite;
  filter: blur(120px);
  position: absolute;
  width: 50%; height: 50%;
  border-radius: 9999px;
  opacity: 0.5;
  z-index: 0;
}

.rotating-background {
  height: 100%; width: 100%;
  position: relative; overflow: hidden;
  background-color: #1B1C1D;
}
.gradient-blur-overlay {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 50%; height: 50%;
  border-radius: 9999px;
  filter: blur(3rem);
}

.progress-bar-container {
  width: 100%; height: 100%;
  z-index: 10;
  display: flex; flex-direction: column;
  align-items: center; justify-content: flex-start; 

  position: relative;
  padding: 3rem 0.5rem 0;

}
.center-loading-img { width: 3rem; height: 3rem; }
@media (min-width: 640px) { .center-loading-img { width: 4rem; height: 4rem; } }

.progress-content {
  display: flex; flex-direction: column;
  align-items: center;
  width: fit-content; max-width: 100%;

}
.waiting-text {
  color: white;   font-size: 1rem; font-weight: 600;
  text-align: center; white-space: nowrap; padding: 0 0.5rem;

}
@media (min-width: 640px) { .waiting-text {  font-size: 1rem; } }

.progress-bar-bg {
  height: 0.25rem;
  width: 85%;
  background-color: #374151;
  border-radius: 9999px;
  overflow: hidden;
  margin-top: -5px;
  display: flex;
}
@media (min-width: 640px) { .progress-bar-bg {  height: 0.4rem; } }

.progress-bar-fill {
  height: 100%;
  background-color: #e50539;
  /* transition: width 0.3s linear;  <-- ISKO HATA DIYA, yahi atakne ki wajah tha */
  will-change: width;
}
.plane-bottom-left {
  position: absolute; 
  left: 0.5rem; 
  bottom: 1.5rem;  
  width: 6rem; 
  height: auto;
}
@media (min-width: 640px) { .plane-bottom-left { width: 8rem;    bottom: 1.5rem;  } }
@media (min-width: 768px) { .plane-bottom-left { width: 10rem;    bottom: 1.5rem; } }

.plane-animation-container {
  position: relative; width: 100%; height: 100%;
  background-color: transparent; overflow: hidden;

}
.animation-canvas {
  position: absolute; top: 0; left: 0;
  width: 100%; height: 100%;
}
.multiplier-overlay {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  display: flex; flex-direction: column; align-items: center;
  z-index: 10; width: 100%; padding: 0 0.5rem;
  pointer-events: none;
}
.flew-away-text {
  margin-bottom: 0.5rem; font-size: 1.3rem;
  font-weight: bold;   color: #fff;   
  filter: drop-shadow(0 4px 3px rgb(0 0 0/0.07));
  text-align: center;
  margin-bottom:-10px;
}
@media (min-width: 640px) { .flew-away-text { margin-bottom: 1rem; font-size: 2.25rem; } }

.multiplier-value {
  font-size: 3.75rem;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-align: center;
  font-variant-numeric: tabular-nums;
  transition: color 0.15s ease;          
  will-change: auto;                    
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  backface-visibility: hidden;       
}

.main-container {
  position: relative; width: 100%;
  background-color: #1B1C1D; overflow: hidden;
  border: 0.5px solid rgba(209, 213, 219, 0.4);
  display: flex; flex-direction: column;
  justify-content: center; align-items: center;
  padding: 0.5rem; min-height: 200px;
  border-radius: 14px;
}

@media (max-width: 430px) {
  .main-container {
    min-height: 175px;
    padding: 0.4rem;
  }
}
@media (min-width: 640px) { .main-container { padding: 1rem; min-height: 250px; } }
@media (min-width: 768px) { .main-container { padding: 2rem; min-height: 400px; } }

.background-layer { position: absolute; inset: 0; z-index: 0; }

.mute-toggle-btn {
  position: absolute;
  top: 8px;   
  left: 8px;        
  z-index: 30;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.progress-phase-overlay {
  position: absolute; width: 100%; height: 100%;
  z-index: 10; display: flex;
  justify-content: center; align-items: center;
}
.animation-phase-overlay {
  position: absolute; inset: 0; z-index: 20;
  display: flex; justify-content: center; align-items: center;
}



.cashout-toast {
  display: flex;
  align-items: center;
  justify-content: center;   
  gap: 8px;    
  background-color: #123104;
  backdrop-filter: blur(4px);
  border-radius: 40px;
  padding: 6px 1px 6px 14px;   
  width: 100%;
  box-sizing: border-box;
}
  
.cashout-toast-stack {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 90%;
  max-width: 320px;
}

.cashout-toast-left {
  display: flex;
  flex-direction: column;
  align-items: center; 
  gap: 2px;
}

.cashout-toast-label {
  color: #cbd5e1;
 font-size: 0.85rem;
  font-weight: 500;
}

.cashout-toast-multiplier {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
}

.cashout-toast-win {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #28A909;
  border-radius: 40px;
 padding: 6px 24px;  
  // margin-right:20px;
}

.cashout-toast-win-label {
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
}

.cashout-toast-win-amount {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}

.cashout-toast-close {
  display: flex;
  flex-direction: column;
  align-items: center;
flex-shrink: 0;  
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #374151;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}
`;

// ─── RotatingBackground ──────────────────────────────────────────────────────
function RotatingBackground({ shouldRotate }) {
  return (
    <div className="rotating-background">
      <img
        src={background}
        alt="background"
        className={`rotating-bg-img${shouldRotate ? " spin-animate" : ""}`}
      />
      {shouldRotate && <div className="gradient-blur-overlay animate-gradient-blur" />}
    </div>
  );
}

// ─── ProgressBar ─────────────────────────────────────────────────────────────

const ProgressBar = React.memo(function ProgressBar({ totalTime = 3.6, active = true, roundKey }) {
  const [planeIndex, setPlaneIndex] = useState(0);
  const startTimeRef = useRef(null);
  const rafRef = useRef(null);
  const fillRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => setPlaneIndex((p) => (p === 0 ? 1 : 0)), 250);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!active) return;

    startTimeRef.current = performance.now();
    if (fillRef.current) fillRef.current.style.width = "100%";

    const animate = (now) => {
      const elapsed = (now - startTimeRef.current) / 1000;
      const p = Math.min((elapsed / totalTime) * 100, 100);
      const remainingWidth = 100 - p;

      if (fillRef.current) {
        fillRef.current.style.width = `${remainingWidth}%`;
      }

      if (p < 100) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };
    rafRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [active, roundKey, totalTime]);

  return (
    <div className="progress-bar-container">
      <img src={centerImg} alt="center" className="center-loading-img animate-spin-fast" />
      <div className="progress-content">
        <p className="waiting-text">WAITING FOR NEXT ROUND</p>
        <div className="progress-bar-bg">
          <div ref={fillRef} className="progress-bar-fill" style={{ width: "100%" }} />
        </div>
      </div>
      <img
        src={planeIndex === 0 ? planeImgOneSrc : planeImgTwoSrc}
        alt="plane"
        className="plane-bottom-left"
      />
    </div>
  );
});



// ─── PlaneAnimation ──────────────────────────────────────────────────────────
function PlaneAnimation({ liveMultiplier, crashed, onCrashAnimDone, onFlyAwayComplete, showCrashedOverlay, hideMultiplierText })  {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const planeImgsRef = useRef([null, null]);
  const startAudioRef = useRef(null);
  const crashAudioRef = useRef(null);
  const crashHandledRef = useRef(false);
    const lastFrameTimeRef = useRef(null);
  const [planeLoaded, setPlaneLoaded] = useState(false);
  const [planeIndex, setPlaneIndex] = useState(0);
  const [isFlyingAway, setIsFlyingAway] = useState(false);
  const [flyAwayProgress, setFlyAwayProgress] = useState(0);
  
  const displayMultiplierRef = useRef(liveMultiplier);
  const targetMultiplierRef  = useRef(liveMultiplier);

  useEffect(() => {
    targetMultiplierRef.current = liveMultiplier;
  }, [liveMultiplier]);

  const liveMultiplierRef  = useRef(liveMultiplier);
  const isFlyingAwayRef    = useRef(isFlyingAway);
  const flyAwayProgressRef = useRef(flyAwayProgress);

  useEffect(() => { liveMultiplierRef.current  = liveMultiplier;  }, [liveMultiplier]);
  useEffect(() => { isFlyingAwayRef.current    = isFlyingAway;    }, [isFlyingAway]);
  useEffect(() => { flyAwayProgressRef.current = flyAwayProgress; }, [flyAwayProgress]);

  useEffect(() => {
    const img1 = new Image();
    const img2 = new Image();
    let loaded = 0;
    const onLoad = () => { if (++loaded === 2) setPlaneLoaded(true); };
    img1.src = planeImgOneSrc;
    img2.src = planeImgTwoSrc;
    img1.onload = img2.onload = onLoad;
    planeImgsRef.current = [img1, img2];
  }, []);

  useEffect(() => {
    const id = setInterval(() => setPlaneIndex(p => p === 0 ? 1 : 0), 120);
    return () => clearInterval(id);
  }, []);

  const multiplierDomRef = useRef(null);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d", { alpha: true });
    if (!ctx) return;
  const now = performance.now();
    const rect = canvas.getBoundingClientRect();
    const dpr  = window.devicePixelRatio || 1;

    if (canvas.width !== rect.width * dpr || canvas.height !== rect.height * dpr) {
      canvas.width  = rect.width  * dpr;
      canvas.height = rect.height * dpr;
      ctx.scale(dpr, dpr);
    }

    const w = rect.width;
    const h = rect.height;
    ctx.clearRect(0, 0, w, h);
const dt = lastFrameTimeRef.current 
  ? Math.min((now - lastFrameTimeRef.current) / 7000, 0.1) 
  : 0.016;
lastFrameTimeRef.current = now;

const target = targetMultiplierRef.current;
const diff = target - displayMultiplierRef.current;


const speedBoost = 1.15; 
const boostedValue = 1 + (target - 1) * speedBoost;

if (multiplierDomRef.current) {
  multiplierDomRef.current.textContent = `${boostedValue.toFixed(2)}x`;
}

const smoothingSpeed = 4.5;
const lerpFactor = 1 - Math.exp(-smoothingSpeed * dt);
displayMultiplierRef.current =
  Math.abs(diff) < 0.001 ? target : displayMultiplierRef.current + diff * lerpFactor;

const currentM = displayMultiplierRef.current;
const isFlying = isFlyingAwayRef.current;
const progress = flyAwayProgressRef.current;


const xAxisY = h * 0.92;
const yAxisX = w * 0.05;

const maxM     = 1.1; 
const pulse    = Math.sin(now / 450) * 0.099 * Math.min((currentM - 1) / maxM, 1);
const curveEndX = w * 0.73;
const maxW     = curveEndX - yAxisX;
const maxH     = h * 0.55;

const points = [];
const step   = 0.004;
const tMax   = Math.max(0, Math.min(currentM - 1, maxM));  
for (let t = 0; t <= tMax; t += step) {
  const norm = t / maxM;
  points.push([
    yAxisX + norm * maxW,
    xAxisY - Math.pow(norm, 3.0) * maxH * (1 + pulse)
  ]);
}
const normEnd = tMax / maxM;
const tipX = yAxisX + normEnd * maxW;
const tipY = xAxisY - Math.pow(normEnd,  3.0) * maxH * (1 + pulse);
if (points.length === 0) points.push([yAxisX, xAxisY]);
else points[points.length - 1] = [tipX, tipY];

    const lastPt = points[points.length - 1];

    if (!isFlying && points.length > 1) {
      const fillGrad = ctx.createLinearGradient(0, lastPt[1], 0, xAxisY);
      fillGrad.addColorStop(0,   "rgba(229,5,57,0.08)");
      fillGrad.addColorStop(0.6, "rgba(180,0,30,0.65)");
      fillGrad.addColorStop(1,   "rgba(140,0,20,0.95)");

      ctx.beginPath();
      ctx.moveTo(yAxisX, xAxisY);
      ctx.lineTo(points[0][0], points[0][1]);
      for (let i = 1; i < points.length - 1; i++) {
        const mx = (points[i][0] + points[i+1][0]) / 2;
        const my = (points[i][1] + points[i+1][1]) / 2;
        ctx.quadraticCurveTo(points[i][0], points[i][1], mx, my);
      }
      ctx.lineTo(lastPt[0], lastPt[1]);
      ctx.lineTo(lastPt[0], xAxisY);
      ctx.closePath();
      ctx.fillStyle = fillGrad;
      ctx.fill();

      const strokeGrad = ctx.createLinearGradient(yAxisX, 0, lastPt[0], 0);
      strokeGrad.addColorStop(0, "rgba(229,5,57,0.4)");
      strokeGrad.addColorStop(1, "rgba(255,70,90,1)");
      ctx.lineWidth   = 5;
      ctx.lineJoin    = "round";
      ctx.lineCap     = "round";
      ctx.strokeStyle = strokeGrad;

      ctx.beginPath();
      ctx.moveTo(points[0][0], points[0][1]);
      for (let i = 1; i < points.length - 1; i++) {
        const mx = (points[i][0] + points[i+1][0]) / 2;
        const my = (points[i][1] + points[i+1][1]) / 2;
        ctx.quadraticCurveTo(points[i][0], points[i][1], mx, my);
      }
      ctx.lineTo(lastPt[0], lastPt[1]);
      ctx.stroke();
    }

    if (planeLoaded && planeImgsRef.current[planeIndex]) {
      let px = lastPt[0];
      let py = lastPt[1];

      if (isFlying) {
        const eased = 1 - Math.pow(1 - progress, 3);
        px += eased * w;
        py -= eased * h;
      }

      const pw = w < 640 ? 95 : 145;
      const ph = w < 640 ? 48 : 72;

      ctx.save();
      ctx.globalAlpha = isFlying ? Math.max(0, 1 - progress * 1.5) : 1;
      ctx.drawImage(planeImgsRef.current[planeIndex], px - pw * 0.1, py - ph * 0.85, pw, ph);
      ctx.restore();
    }
  }, [planeLoaded, planeIndex]);

  useEffect(() => {
    const loop = () => { draw(); rafRef.current = requestAnimationFrame(loop); };
    rafRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafRef.current);
  }, [draw]);

useEffect(() => {
    if (!crashed || crashHandledRef.current) return;
    crashHandledRef.current = true;

    setIsFlyingAway(true);
    let start = null;
    const duration = 2000;
    const audio = crashAudioRef.current;
    let audioPlayed = false;

    const anim = (ts) => {
      if (!start) start = ts;
      const prog = Math.min((ts - start) / duration, 1);
      setFlyAwayProgress(prog);

      // Plane jab tak visible hai (globalAlpha > 0), tabhi crash sound bajao
      // globalAlpha = 1 - prog * 1.5, so it hits 0 around prog = 0.66
      if (!audioPlayed && prog >= 0.1) {
        audioPlayed = true;
        if (audio) {
          audio.currentTime = 0;
          audio.volume = 1;
          audio.play().catch((err) => console.warn('crash audio blocked:', err));
        }
      }

      if (prog < 1) {
        requestAnimationFrame(anim);
      } else {
        onFlyAwayComplete?.();
        setTimeout(onCrashAnimDone, 800);
      }
    };
    requestAnimationFrame(anim);
}, [crashed]);
  useEffect(() => {
    startAudioRef.current?.play().catch(() => {});
  }, []);

  return (
    <div className="plane-animation-container">
      <audio ref={startAudioRef} src={startSound} preload="auto" />
      <audio ref={crashAudioRef} src={crashSound} preload="auto" />

      <canvas
        ref={canvasRef}
        className="animation-canvas"
        style={{ display: "block", width: "100%", height: "100%" }}
      />

      <div className="multiplier-overlay">
        {showCrashedOverlay && <div className="flew-away-text">FLEW AWAY!</div>}
        {!hideMultiplierText && (
          <div
            ref={multiplierDomRef}
            className="multiplier-value"
            style={{ color: isFlyingAway ? "#e50539" : "#fff" }}
          >
            {liveMultiplier.toFixed(2)}x
          </div>
        )}
      </div>
    </div>
  );
}


function CashoutToast({ multiplier = "1.08x", amount = "54.00", onClose }) {
  return (
    <div className="cashout-toast">
      <div className="cashout-toast-left">
        <span className="cashout-toast-label">You have cashed out!</span>
        <span className="cashout-toast-multiplier">{multiplier}</span>
      </div>
      <div className="cashout-toast-win">
        <span className="cashout-toast-win-label">Win ₹</span>
        <span className="cashout-toast-win-amount">{amount}</span>
      </div>
      <div className="cashout-toast-close" onClick={onClose}>×</div>
    </div>
  );
}

// ─── Main Component ──────────────────────────────────────────────────────────
export default function GameScreen({ cashoutToasts }) {
  const aviatorData = useSelector((state) => state.aviator);
  const lastMessage = aviatorData?.lastMessage;

  const phase      = lastMessage?.phase        || "BETTING";
  const multiplier = lastMessage?.multiplier   || 0;
  const remaining  = lastMessage?.remainingTime ?? 0;


  const [waitCountdown, setWaitCountdown] = useState(3);
  const waitTimerRef = useRef(null);
  const prevPhaseRef = useRef(phase);
const [bettingRoundKey, setBettingRoundKey] = useState(0);
const prevPhaseForKeyRef = useRef(phase);

useEffect(() => {
  if (phase === "BETTING" && prevPhaseForKeyRef.current !== "BETTING") {
    setBettingRoundKey((k) => k + 1);
  }
  prevPhaseForKeyRef.current = phase;
}, [phase]);
  useEffect(() => {

    if (phase === "WAITING" && prevPhaseRef.current !== "WAITING") {
      setWaitCountdown(3);
      if (waitTimerRef.current) clearInterval(waitTimerRef.current);

      waitTimerRef.current = setInterval(() => {
        setWaitCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(waitTimerRef.current);
            waitTimerRef.current = null;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }


    if (phase !== "WAITING" && waitTimerRef.current) {
      clearInterval(waitTimerRef.current);
      waitTimerRef.current = null;
    }

    prevPhaseRef.current = phase;
  }, [phase]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (waitTimerRef.current) clearInterval(waitTimerRef.current);
    };
  }, []);


  const betting = phase === "BETTING";
  const waiting = phase === "WAITING";
  const flying  = phase === "FLYING" || phase === "CRASHED";
  const crashed = phase === "CRASHED";

  const [showCrashedOverlay, setShowCrashedOverlay] = useState(false);

  const bgAudioRef       = useRef(null);
  const audioUnlockedRef = useRef(false);
  const [isMuted, setIsMuted] = useState(false);

  const toggleMute = () => {
    setIsMuted((prev) => {
      const newMuted = !prev;
      if (bgAudioRef.current) {
        bgAudioRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

  useEffect(() => {
    const audio  = new Audio(bgAudio);
    audio.loop   = true;
    audio.volume = 0.4;
    audio.muted  = isMuted;
    bgAudioRef.current = audio;

    const unlock = () => {
      if (audioUnlockedRef.current) return;
      audioUnlockedRef.current = true;
      audio.play().catch(() => {});
      window.removeEventListener("click", unlock);
      window.removeEventListener("touchstart", unlock);
    };

    window.addEventListener("click", unlock);
    window.addEventListener("touchstart", unlock);

    return () => {
      audio.pause();
      audio.src = "";
      window.removeEventListener("click", unlock);
      window.removeEventListener("touchstart", unlock);
    };
  }, []);

  useEffect(() => {
    bgAudioRef.current?.play().catch(() => {});
  }, [phase]);



  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = cssStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="main-container">
      <div className="background-layer">
        <RotatingBackground shouldRotate={flying} />
      </div>

      <div className="mute-toggle-btn" onClick={toggleMute}>
        {isMuted ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M11 5L6 9H2v6h4l5 4V5z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
            <line x1="23" y1="9" x2="17" y2="15" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="17" y1="9" x2="23" y2="15" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M11 5L6 9H2v6h4l5 4V5z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M18.36 5.64a9 9 0 0 1 0 12.73" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        )}
      </div>

{betting && (
  <div className="progress-phase-overlay">
    <ProgressBar totalTime={4.8} active={betting} roundKey={bettingRoundKey} />
  </div>
)}

 {waiting && (
  <div className="progress-phase-overlay">
    <PlaneAnimation
      liveMultiplier={multiplier}
      crashed={false}
      onFlyAwayComplete={() => {}}
      onCrashAnimDone={() => {}}
      showCrashedOverlay={false}
      hideMultiplierText={false}
    />
  </div>
)}

      {flying && (
        <div className="animation-phase-overlay">
          <PlaneAnimation
            liveMultiplier={multiplier}
            crashed={crashed}
            onFlyAwayComplete={() => setShowCrashedOverlay(true)}
            onCrashAnimDone={() => setShowCrashedOverlay(false)}
            showCrashedOverlay={showCrashedOverlay}
          />
        </div>
      )}

{cashoutToasts && cashoutToasts.some(Boolean) && (
  <div className="cashout-toast-stack">
    {cashoutToasts.map((toast, idx) => {
      if (!toast) return null;

      const mult = Number(toast.multiplier);
      const amt = Number(toast.amount);

      if (!Number.isFinite(mult) || !Number.isFinite(amt)) return null;

      return (
        <CashoutToast
          key={idx}
          multiplier={`${mult.toFixed(2)}x`}
          amount={amt.toFixed(2)}
          onClose={() => {}}
        />
      );
    })}
  </div>
)}

    </div>
  );
}